var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"clearfix mb-0"},[_c('span',{staticClass:"float-md-right d-none d-md-block"},[_vm._v(" Desenvolvido pela "),_c('b-link',{attrs:{"href":"https://espressolabs.com.br","target":"_blank"}},[_vm._v("Espresso Labs")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }